import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { heroImage, purchaseNotifications } from '../data/content';
const SHOW_AFTER_MS = 9000;
const VISIBLE_MS = 6000;
const GAP_MS = 12000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let timeoutId: number;
    let cancelled = false;
    const show = () => {
      if (cancelled) return;
      setVisible(true);
      timeoutId = window.setTimeout(hide, VISIBLE_MS);
    };
    const hide = () => {
      if (cancelled) return;
      setVisible(false);
      setIndex(prev => (prev + 1) % purchaseNotifications.length);
      timeoutId = window.setTimeout(show, GAP_MS);
    };
    timeoutId = window.setTimeout(show, SHOW_AFTER_MS);
    return () => {
      cancelled = true;
      window.clearTimeout(timeoutId);
    };
  }, []);
  const item = purchaseNotifications[index];
  return <AnimatePresence data-id="element-228" data-mp="164xr1581v2o9">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 12,
      scale: 0.97
    }} transition={{
      duration: 0.24,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-3 right-3 z-40 sm:right-auto sm:max-w-[330px]" role="status" aria-live="polite" data-id="element-229" data-mp="163whj56omo8n">
          <div className="flex items-center gap-3 rounded-2xl border border-ink/10 bg-white p-3 shadow-card" data-id="element-230" data-mp="n97ptk7xyabf">
            <img src={heroImage} alt="" className="h-12 w-12 shrink-0 rounded-lg bg-cream object-contain" data-id="element-231" data-mp="x5azrc91bd8x" />
            <div className="min-w-0" data-id="element-232" data-mp="s4mzdzyx1k21">
              <p className="truncate text-[13px] font-bold text-ink" data-id="element-233" data-mp="28kg4elsq7lv6">
                {item.name} · {item.city}, {item.country}
              </p>
              <p className="truncate text-[12px] text-clay" data-id="element-234" data-mp="23kld4h51gu9l">
                just purchased Resin Architect™
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] font-semibold text-success" data-id="element-235" data-mp="2aobbwi679qtv">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-236" data-mp="2fpr0ulbi0hhj" />
                Verified purchase · a few seconds ago
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}